import React from "react";
import { createRoot } from "react-dom";
import { Provider } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';

import App from "./App";
import store from "./redux/store";

import "./index.css";

class WebComponent extends HTMLElement {
  constructor() {
    super();
    createRoot(this).render(
        <Provider store={store}>
          <div className="conference-details-custom-element">
            <App/>
          </div>
        </Provider>
    );
  }
}
const ELEMENT_ID = "ku-kuconnect-custom-element-conference-registration";
if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
